// @ts-nocheck
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { BLUE } from '../../_config/consts';
import EmptyView from '../EmptyView.jsx';
import PowerControlUnitEventRow from './PowerControlUnitEventRow.jsx';

const styles = {
  circularProgress: {
    color: BLUE,
  },
};

class PowerControlUnitEventsList extends React.Component {
  render() {
    const {
      classes,
      events,
      pagination: { number, last },
      viewLoading,
      listStyle,
      onLoadMore,
      hasMore,
    } = this.props;

    return (
      <div style={{ overflowY: 'auto', height: '120vh', paddingLeft: 15, paddingRight: 5, paddingBottom: 220, ...listStyle }}>
        <InfiniteScroll
          initialLoad={false}
          loadMore={onLoadMore ? () => onLoadMore(number + 1) : null}
          hasMore={hasMore !== undefined ? hasMore : !last}
          useWindow={false}
          loader={onLoadMore ? (
            <div style={{
              marginTop: 20,
              backgroundColor: 'white',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              paddingVertical: 5,
            }}
            >
              <h4 style={{ textAlign: 'center', color: '#3f3f3f' }}>
                <Entity entity="loadingLogs" />
              </h4>
              <CircularProgress className={classes.circularProgress} />
            </div>
          ) : null}
        >
          <div>
            {!_.isEmpty(events) ? (
              _.map(events, (event, index) => (
                <PowerControlUnitEventRow key={event.id || index} event={event} />
              ))
            ) : (
              <div>
                {!viewLoading && (
                  <EmptyView
                    entityName="events"
                    title="noPowerControlUnitsEventsTitle"
                    subtitle="noPowerControlUnitsEventsSubtitle"
                  />
                )}
              </div>
            )}
          </div>
        </InfiniteScroll>
      </div>
    );
  }
}

export default withStyles(styles)(PowerControlUnitEventsList);
